import {ItemPopupMenu, MenuPosition, PopupMenuItem} from "@dv5/components"
import {ItemAction, Widget} from "@dv5/domain"
import {MoveWidgetsToLayersDialog} from "../components/MoveWidgetsToLayersDialog"
import {AssignWidgetsToTagsDialog} from "../components/AssignWidgetsToTagsDialog"
import {AlignWidgetsBar} from "../components/align/AlignWidgetsBar"
import {FC} from "react"

interface Props {
    showMenu: boolean
    menuPosition: MenuPosition
    menuItems: PopupMenuItem[]
    onMenuItem: (action: ItemAction) => void
    onHideMenu: () => void

    showMoveWidgetsToLayersDialog: boolean
    onMoveWidgetsToLayers: (layerIds: string[]) => void
    onCloseMoveWidgetsToLayersDialog: () => void
    additionalId: string
    additionalType: string

    showAssignWidgetsToTagsDialog: boolean
    onAssignWidgetsToTags: (tagIds: string[]) => void
    onCloseAssignWidgetsToTagsDialog: () => void

    showAlignBar: boolean
    canvasId: string
    widgets: Widget[]
    canvasSelection: string[]
    affectedWidgets: Widget[]
    onCloseAlignBar: () => void
}

export const CanvasPopups: FC<Props> = ({
    showMenu,
    menuPosition,
    menuItems,
    onMenuItem,
    onHideMenu,
    showMoveWidgetsToLayersDialog,
    onMoveWidgetsToLayers,
    onCloseMoveWidgetsToLayersDialog,
    additionalId,
    additionalType,
    showAssignWidgetsToTagsDialog,
    onAssignWidgetsToTags,
    onCloseAssignWidgetsToTagsDialog,
    showAlignBar,
    canvasId,
    widgets,
    canvasSelection,
    affectedWidgets,
    onCloseAlignBar,
}) => (
    <>
        <ItemPopupMenu
            showMenu={showMenu}
            menuPosition={menuPosition}
            menuItems={menuItems}
            onMenuItem={onMenuItem}
            onHide={onHideMenu}
        />
        {showMoveWidgetsToLayersDialog && (
            <MoveWidgetsToLayersDialog
                isOpen={showMoveWidgetsToLayersDialog}
                onClose={onCloseMoveWidgetsToLayersDialog}
                onMove={onMoveWidgetsToLayers}
                additionalId={additionalId}
                additionalType={additionalType}
                widgets={affectedWidgets}
            />
        )}
        {showAssignWidgetsToTagsDialog && (
            <AssignWidgetsToTagsDialog
                isOpen={showAssignWidgetsToTagsDialog}
                onClose={onCloseAssignWidgetsToTagsDialog}
                onAssign={onAssignWidgetsToTags}
                additionalId={additionalId}
                additionalType={additionalType}
            />
        )}
        {showAlignBar && (
            <AlignWidgetsBar
                canvasId={canvasId}
                widgets={widgets}
                selectedIds={canvasSelection}
                onClose={onCloseAlignBar}
            />
        )}
    </>
)
